import React from 'react'
import { motion } from "framer-motion"
import Banner from '../components/Banner'



const Sertifikalarimiz = () => {

  const list = {
    visible: {
      opacity: 1,

      transition: {
        when: "beforeChildren",
        staggerChildren: 0.1,
      },
    },
    hidden: { opacity: 0 },

  }





  const images = [
    { id: 0, src: '/image/tedak-sertifikalar/iso-9001.png', pdf: '/image/tedak-sertifikalar/iso-9001.pdf', title: 'ISO 9001' },
    { id: 1, src: '/image/tedak-sertifikalar/iso-14001.png', pdf: '/image/tedak-sertifikalar/iso-14001.pdf', title: 'ISO 14001' },
    { id: 2, src: '/image/tedak-sertifikalar/iso-45001.png', pdf: '/image/tedak-sertifikalar/iso-45001.pdf', title: 'ISO 45001' },
    { id: 3, src: '/image/tedak-sertifikalar/iso-50001.png', pdf: '/image/tedak-sertifikalar/iso-50001.pdf', title: 'ISO 50001' },
    { id: 4, src: '/image/tedak-sertifikalar/tedak-ce-lvd.png', pdf: '/image/tedak-sertifikalar/tedak-ce-lvd.pdf', title: 'CE LVD' },
    { id: 5, src: '/image/tedak-sertifikalar/tedak-sertifikasi-numarasi-kg.png', pdf: '/image/tedak-sertifikalar/tedak-sertifikasi-numarasi-kg.pdf', title: 'Sertifika Numarası KG' },
    { id: 6, src: '/image/tedak-sertifikalar/zertifikat_lv0943.png', pdf: '/image/tedak-sertifikalar/zertifikat_lv0943.pdf', title: 'Zertifikat LV0943' },
  ];

  const handleImageClick = (item) => {
    if (item.pdf) {
      window.open(item.pdf, '_blank');
    }
  };
  return (
    <div className='  '>
      <Banner />
      <motion.div initial="hidden" whileInView="visible" variants={list} className='  w-full bg-white  z-10 inner-container '>
        <h5 className='general-heading '> Sertifikalarımız</h5>

        <div className='grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 my-14 gap-5 '>
          {

            
            images.map((item, index) => {
              return (
                <div className='hover:shadow-md transition-all duration-500 hover:scale-105'>
                <motion.div
                key={index}
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ delay: index * 0.1, duration: 0.5 }}
                className='border border-gray-300 p-1 bg-white shadow-sm '
                
              >
                <img   onClick={() => handleImageClick(item)}  key={item.id} src={item.src} alt={item.title} className=' cursor-pointer w-full h-auto' />
                </motion.div>
                </div>
              )
            })
          }
        </div>









      </motion.div>
    </div>
  )
}

export default Sertifikalarimiz